import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const NotFoundPage = () => (
  <div
    data-testid="public-404-page"
    style={{
      minHeight: "60vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: "80px 24px",
      backgroundColor: "#FFFFFF",
    }}
  >
    <Helmet>
      <title>Page Not Found | Elvis Aloha Collection</title>
      <meta name="robots" content="noindex, follow" />
    </Helmet>
    <div>
      <p
        style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: "clamp(64px, 12vw, 120px)",
          fontWeight: 500,
          color: "#0D273C",
          margin: "0 0 8px",
          lineHeight: 1,
        }}
      >
        404
      </p>
      <h1
        style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: "clamp(22px, 3vw, 30px)",
          fontWeight: 500,
          color: "#0D273C",
          margin: "0 0 12px",
        }}
      >
        Page Not Found
      </h1>
      <p
        style={{
          fontFamily: "'Source Sans 3', sans-serif",
          fontSize: "15px",
          color: "#666",
          maxWidth: "420px",
          margin: "0 auto 32px",
          lineHeight: 1.6,
        }}
      >
        The page you're looking for doesn't exist or may have moved.
      </p>
      <Link
        to="/"
        data-testid="public-404-home-link"
        style={{
          display: "inline-flex",
          alignItems: "center",
          padding: "14px 28px",
          background: "#0D273C",
          color: "#F7F1E5",
          textDecoration: "none",
          fontFamily: "'Source Sans 3', sans-serif",
          fontSize: "13px",
          fontWeight: 700,
          letterSpacing: "0.08em",
          textTransform: "uppercase",
          borderRadius: "4px",
        }}
      >
        Return Home
      </Link>
    </div>
  </div>
);

export default NotFoundPage;
